import React from 'react'
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './dialog'

interface ImagePreviewModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  imageUrl: string | null
  altText?: string
}

export function ImagePreviewModal({
  open,
  onOpenChange,
  imageUrl,
  altText = 'Vista previa de imagen',
}: ImagePreviewModalProps) {
  if (!imageUrl) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl border-none bg-transparent p-0 shadow-none">
        <DialogTitle className="sr-only">Previsualización de Imagen</DialogTitle>
        <DialogDescription className="sr-only">
          Vista ampliada de la imagen seleccionada.
        </DialogDescription>
        <div className="flex items-center justify-center p-4">
          <img
            src={imageUrl}
            alt={altText}
            className="max-h-[85vh] w-auto max-w-full rounded-md object-contain shadow-2xl"
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
